import React from "react";
import styles from "./H1.scss";
import classNames from "classnames";

export const H1 = ({ children, margin }) => {
    return (
        <h1
            className={classNames(styles.h1, {
                [styles.marginNone]: margin === "none"
            })}
        >
            {children}
        </h1>
    );
};
